var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('figure',{staticClass:"main-img-section"},[_c('img',{attrs:{"src":_vm.mainImg,"alt":_vm.imgName}}),_c('MouseIcon',{staticClass:"floating-mouse-icon"}),_c('div',{staticClass:"overlay"})],1),_c('div',{staticClass:"content-separator"}),_c('div',{staticClass:"main-content-section"},[_vm._t("grid-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }